<!--
  SelectedWhereaboutsInfo.vue
    現在選択されているメンバ場所情報Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
  <!-- ローディング画面 -->
  <loading ref="loading"></loading>

  <v-card>  <!-- 送信ボタンを表示するためのダミーcard(div要素ではうまく配置されない) -->
    <update-btn @updateWhereabouts="onUpdateWhereabouts"/>
  </v-card>

  <!-- スマホ版 -->
  <div class="hm-display-mobile">
  <!-- @Memo classのpa-xを変更すると全体のmarginサイズを変えることができる -->
  <v-container text-xs-center class="pa-1 hm-swi">
    <!-- 在席状態アイコンのスライド操作と重なるため、swipeを削除
    <div v-touch="{
      left: () => onSwipe('left'),
      right: () => onSwipe('right'),
    }">
    -->

    <!-- ユーザ情報 -->
    <v-layout wrap align-center class="hm-bg-primary hm-clr-prim-white hm-swi-profile">
      <v-flex xs2></v-flex>
      <v-flex xs2 class="hm-swi-avatar">
        <div :class="{'hm-hide': !isAvatarAvailable}">
          <v-avatar :size="this.mAvatarSizeMoobile">
            <img :src="mSelectedUserInfo.avatar">
          </v-avatar>
        </div>
        <div :class="{'hm-hide': isAvatarAvailable}">
          <v-avatar :size="this.mAvatarSizeMoobile" color="grey lighten-1">
            <v-icon :size="this.mAvatarSizeMoobile" color="grey lighten-4">person</v-icon>
          </v-avatar>
        </div>
      </v-flex>
      <v-flex xs5 class="hm-swi-name">
        <div class="hm-swi-usersection hm-ellipsis">{{ mSelectedUserInfo.section }} {{ mSelectedUserInfo.group }}</div>
        <div class="hm-swi-userclass hm-ellipsis">{{ mSelectedUserInfo.class }}</div>
        <div class="hm-swi-username hm-ellipsis">{{ mWhereaboutsInfo.name }}</div>
      </v-flex>
      <v-flex xs1>
        <div v-if="attendanceAvailable === true">
          <!-- ログインユーザで勤怠管理フラグON -->
          <v-tooltip v-if="mLinkedTw === 0" bottom>
            <!-- 連動OFFの場合、勤怠入力アイコンを表示 -->
            <v-btn slot="activator" flat icon @click="onClickAttendanceSend">
              <v-icon mediun color="white">more_time</v-icon>
            </v-btn>
            <span>勤怠入力</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex xs2>
        <!-- 連絡先連携-->
        <!--20220524 y.jin
        ※メール連携機能(電話連携と同時リリースするため、リリース保留)
        <div v-if="isLoginUser === false">
          <v-btn slot="activator" flat icon @click="onClickMail">
            <v-icon mediun color="white">email</v-icon>
          </v-btn>
        </div>
        -->
      </v-flex>
    </v-layout>

    <div class="hm-swi-updatedate">{{ mWhereaboutsInfo.update_date | formatUpdateDate }}</div>

    <!-- 在席状態 -->
    <v-layout wrap>
      <v-flex xs4></v-flex>
      <v-flex xs4>
        <div @click="onClickCurrentPresence">
        <v-card :color="currentPresence.icon_color" class="hm-swi-presence-card">
          <v-icon color="white" size="12vw">
            {{ currentPresence.icon_name }}
          </v-icon>

          <div class="hm-swi-presence-text hm-ellipsis">
            {{ currentPresence.st_name }}
          </div>
        </v-card>
        </div>
      </v-flex>
      <v-flex xs4>
        <div :class="{'hm-hidden': !goDirect}" class="hm-swi-direct-go">直行</div>
        <!--<div :class="{'hm-hide': goDirect}" class="hm-swi-direct-go hm-trans-30">直行</div>-->
        <div :class="{'hm-hidden': !comeDirect}" class="hm-swi-direct-bk">直帰</div>
        <!--<div :class="{'hm-hide': comeDirect}" class="hm-swi-direct-bk hm-trans-30">直帰</div>-->
        <!--
        <div :class="{'hm-hidden': comeDirect}" class="hm-swi-direct-bk-na hm-trans-30">直帰</div>
        -->
      </v-flex>
    </v-layout>

    <v-divider />

    <!-- 在席状態選択アイコンリスト -->
    <div class="hm-swi-scroll-wrapper">
      <v-avatar
        size="10vw"
        v-for="presence in mPresenceStatusList"
        :key=presence.state_id
        :color=presence.icon_color
        class="hm-swi-icon-back"
        @click="onClickPresenceIcon(presence.state_id, presence.linked_wh_category)"
      >
        <v-icon color="white" size="6vw">{{ presence.icon_name }}</v-icon>
      </v-avatar>
      <!--
      <v-btn
        icon
        large
        v-for="presence in mPresenceStatusList"
        :key=presence.state_id
        :color=presence.icon_color
        class="hm-swi-iconlist hm-trans-30"
        @click="onClickPresenceIcon(presence.state_id)"
      >
        <v-icon size="6vw" color="white">{{ presence.icon_name }}</v-icon>
      </v-btn>
      -->
    </div>

    <v-divider />

    <!-- 行先情報詳細 -->
    <!--
    <div class="hm-swi-place-detail hm-swi-box">
      -->
    <div class="hm-swi-box">
      <!--
      <v-card>
        <v-fab-transition>
          <v-btn color="light-green darken-4" fab dark small absolute top right @click="onClickEditWhereabouts">
            <v-icon>mode_edit</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-card>

      <div class="hm-bg-primary hm-clr-prim-white hm-swi-whereabouts-title">{{ $t("placeinfo.placeinfo") }}</div>
      -->

      <div class="hm-swi-whereabouts-list-title">
        {{ $t("placeinfo.place") }}
      </div>
      <div class="hm-swi-whereabouts-list-body">
        <v-select
          :items="mPlaceListStore"
          item-text="dist_name"
          item-value="dist_id"
          placeholder=""
          single-line
          menu-props="bottom"
          v-model="mWhereaboutsInfo.dist"
          @click="onClickDist()"
        ></v-select>
      </div>

      <v-layout align-center>
        <v-flex xs10 class="hm-swi-whereabouts-list-title">
        {{ $t("placeinfo.retdatetime") }}
        <v-btn small flat icon color="primary" @click="onClickDatetimeClear">
          <v-icon>backspace</v-icon>
        </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row justify-space-around>
        <v-flex xs5>
          <v-menu
            ref="datemenu"
            lazy
            :close-on-content-click="false"
            v-model="mDpicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            :return-value.sync="mWhereaboutsInfo.ret_date"
          >
            <v-text-field
              class="hm-ewd-text-date"
              slot="activator"
              label="Date"
              v-model="mWhereaboutsInfo.ret_date"
              readonly
              background-color="grey lighten-2"
              @focus="onRetDateFocus"
            ></v-text-field>

            <v-date-picker v-model="mWhereaboutsInfo.ret_date" scrollable>
              <v-btn flat color="primary" @click="mDpicker = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.datemenu.save(mWhereaboutsInfo.ret_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs5>
          <v-menu
            ref="timemenu"
            lazy
            :close-on-content-click="false"
            v-model="mTpicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            :return-value.sync="mWhereaboutsInfo.ret_time"
          >
            <v-text-field
              class="hm-ewd-text-time"
              slot="activator"
              label="Time"
              v-model="mWhereaboutsInfo.ret_time"
              readonly
              background-color="grey lighten-2"
              @click="onClickRetTime()"
            ></v-text-field>
            <v-time-picker
              v-if="mTpicker"
              v-model="mTmpRetTime"
              format="24hr"
              :allowed-minutes="allowedMinutes"
              actions
            >
              <v-btn flat color="primary" @click="onClickRetTimeCancel()">Cancel</v-btn>
              <v-btn flat color="primary" @click="onClickRetTimeOk()">OK</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-layout align-center>
        <v-flex xs10 class="hm-swi-whereabouts-list-title">
        {{ $t("placeinfo.detail") }}
        <v-btn small icon flat color="primary" @click="onClickMemoClear">
          <v-icon>backspace</v-icon>
        </v-btn>
        </v-flex>
      </v-layout>

      <!-- mouseover/outでforcus/blurを検知する(他の良い方法が不明) -->
      <v-form v-model="mSwiFormValid">
        <v-textarea
          v-model="mWhereaboutsInfo.comment"
          :rules="[mSwiCommentRules.counter]"
          box
          rows="4"
          label="Memo"
          @focus="onMemoFocus"
          @blur="onMemoBlur"
        ></v-textarea>
      </v-form>

    </div>
    <!--<div style="height: 300px; width: 100%; background: pink;"></div>-->
     <!--
    </div><!- v-touch ->
    -->
  </v-container>
  </div>

  <!-- -------------------------------------------------------------------------------- -->
  <!-- ブラウザ版 -->
  <div class="hm-display-monitor">
  <!-- @Memo classのpa-xを変更すると全体のmarginサイズを変えることができる -->
  <v-container text-xs-center class="pa-1 hm-swi">

    <v-layout wrap align-center class="hm-bg-primary hm-clr-prim-white hm-swi-profile">
      <v-flex xs3></v-flex>
      <!-- プロフィール画像 -->
      <v-flex xs2 class="hm-swi-avatar">
        <div :class="{'hm-hide': !isAvatarAvailable}">
          <v-avatar :size="this.mAvatarSizeMonitor">
            <img :src="mSelectedUserInfo.avatar">
          </v-avatar>
        </div>
        <div :class="{'hm-hide': isAvatarAvailable}">
          <v-avatar :size="this.mAvatarSizeMonitor" color="grey lighten-1">
            <v-icon :size="this.mAvatarSizeMonitor" color="grey lighten-4">person</v-icon>
          </v-avatar>
        </div>
      </v-flex>
      <!-- ユーザ情報 -->
      <v-flex xs4 class="hm-swi-name">
        <v-tooltip bottom class="hm-swi-usersection">
          <template slot="activator">
             <div class="hm-ellipsis">{{ mSelectedUserInfo.section }} {{ mSelectedUserInfo.group }}</div>
          </template>
          <span>{{ mSelectedUserInfo.section }} {{ mSelectedUserInfo.group }}</span>
        </v-tooltip>
        <v-tooltip bottom class="hm-swi-userclass">
          <template slot="activator">
             <div class="hm-ellipsis">{{ mSelectedUserInfo.class }}</div>
          </template>
          <span>{{ mSelectedUserInfo.class }}</span>
        </v-tooltip>
        <v-tooltip bottom class="hm-swi-username">
          <template slot="activator">
             <div class="hm-ellipsis">{{ mWhereaboutsInfo.name }}</div>
          </template>
          <span>{{ mWhereaboutsInfo.name }}</span>
        </v-tooltip>
      </v-flex>
      <!-- 勤怠入力ボタン -->
      <v-flex xs1>
        <div v-if="attendanceAvailable === true">
          <!-- 連動OFFの場合、勤怠入力アイコンを表示 -->
          <v-tooltip v-if="mLinkedTw === 0" bottom>
            <v-btn slot="activator" flat icon @click="onClickAttendanceSend">
              <v-icon mediun color="white">more_time</v-icon>
            </v-btn>
            <span>勤怠入力</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex xs2>
        <!-- 連絡先連携
        20220524 y.jin
        ※メール連携機能(電話連携と同時リリースするため、リリース保留)
        <div v-if="isLoginUser === false">
          <a v-bind:href="`mailto:${mSelectedUserInfo.mail}`" flat icon>
            <v-icon mediun color="white">email</v-icon>
          </a>
        </div>
        -->
      </v-flex>
    </v-layout>

    <div class="hm-swi-updatedate">{{ mWhereaboutsInfo.update_date | formatUpdateDate }}</div>

    <!-- 在席状態 -->
    <v-layout wrap>
      <v-flex xs4></v-flex>
      <v-flex xs4>
        <div @click="onClickCurrentPresence">
        <v-card :color="currentPresence.icon_color" class="hm-swi-presence-card hm-cursor">
          <v-icon color="white" size="2.75vw">
            {{ currentPresence.icon_name }}
          </v-icon>
          <div class="hm-swi-presence-text hm-ellipsis">
            {{ currentPresence.st_name }}
          </div>
        </v-card>
        </div>
      </v-flex>
      <v-flex xs4>
        <div :class="{'hm-hidden': !goDirect}" class="hm-swi-direct-go">直行</div>
        <div :class="{'hm-hidden': !comeDirect}" class="hm-swi-direct-bk">直帰</div>
      </v-flex>
    </v-layout>

    <v-divider />

    <!-- 在席状態選択アイコンリスト -->
    <div class="hm-swi-scroll-wrapper">
      <v-avatar
        size="3vw"
        v-for="presence in mPresenceStatusList"
        :key=presence.state_id
        :color=presence.icon_color
        class="hm-swi-icon-back hm-cursor"
        @click="onClickPresenceIcon(presence.state_id, presence.linked_wh_category)"
      >
        <v-tooltip bottom>
          <v-icon slot="activator" color="white" size="2vw">{{ presence.icon_name }}</v-icon>
          <span>{{ presence.st_name }}</span>
        </v-tooltip>
      </v-avatar>
      <!--
      <v-btn
        icon
        large
        v-for="presence in mPresenceStatusList"
        :key=presence.state_id
        :color=presence.icon_color
        class="hm-swi-iconlist hm-trans-30"
        @click="onClickPresenceIcon(presence.state_id)"
      >
        <v-icon size="2vw" color="white">{{ presence.icon_name }}</v-icon>
      </v-btn>
      -->
    </div>

    <v-divider />

    <v-layout wrap text-xs-center class="hm-swi-box">
      <v-flex xs6 class="pa-1">

        <div class="hm-swi-whereabouts-list-title">{{ $t("placeinfo.place") }}</div>
        <div class="hm-swi-whereabouts-list-body">
          <v-select
            :items="mPlaceListStore"
            item-text="dist_name"
            item-value="dist_id"
            single-line
            menu-props="bottom"
            v-model="mWhereaboutsInfo.dist"
            @click="onClickDist()"
          ></v-select>
        </div>

        <v-layout>
          <v-flex xs10 class="hm-swi-whereabouts-list-title">
          {{ $t("placeinfo.retdatetime") }}
          </v-flex>
          <v-flex xs2>
          <v-btn small flat icon color="primary" @click="onClickDatetimeClear">
            <v-icon>backspace</v-icon>
          </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row justify-space-around>
          <v-flex xs5>
            <v-menu
              ref="datemenuMon"
              lazy
              :close-on-content-click="false"
              v-model="mDpickerMon"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
              :return-value.sync="mWhereaboutsInfo.ret_date"
            >
              <v-text-field
                slot="activator"
                label="Date"
                v-model="mWhereaboutsInfo.ret_date"
                readonly
                background-color="grey lighten-2"
              ></v-text-field>

              <v-date-picker v-model="mWhereaboutsInfo.ret_date" scrollable>
                <v-btn flat color="primary" @click="mDpickerMon = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.datemenuMon.save(mWhereaboutsInfo.ret_date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs5>
            <v-menu
              ref="timemenuMon"
              lazy
              :close-on-content-click="false"
              v-model="mTpickerMon"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              :return-value.sync="mWhereaboutsInfo.ret_time"
            >
              <v-text-field
                class="hm-ewd-text-time"
                slot="activator"
                label="Time"
                v-model="mWhereaboutsInfo.ret_time"
                readonly
                background-color="grey lighten-2"
                @click="onClickRetTime()"
              ></v-text-field>
              <v-time-picker
                v-if="mTpickerMon"
                v-model="mTmpRetTime"
                format="24hr"
                :allowed-minutes="allowedMinutes"
                actions
              > <!--v-ifによって、再度時間設定画面を表示したときに時間から入力できるようになる-->
                <v-btn flat color="primary" @click="onClickRetTimeCancel()">Cancel</v-btn>
                <v-btn flat color="primary" @click="onClickRetTimeOk()">OK</v-btn>
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>

      </v-flex><!-- 下段左側 -->

      <v-flex xs6 class="pa-1">

        <v-layout>
          <v-flex xs10 class="hm-swi-whereabouts-list-title">
          {{ $t("placeinfo.detail") }}
          </v-flex>
          <v-flex xs2>
          <v-btn small flat icon color="primary" @click="onClickMemoClear">
            <v-icon>backspace</v-icon>
          </v-btn>
          </v-flex>
        </v-layout>

        <v-form v-model="mSwiFormValid">
          <v-textarea
            v-model="mWhereaboutsInfo.comment"
            :rules="[mSwiCommentRules.counter]"
            rows="5"
            box
            label="Memo"
          ></v-textarea>
        </v-form>

      </v-flex>

    </v-layout>

  </v-container>

  </div>

    <!-- 行動予定編集Dialog -->
    <!--
    <edit-whereabouts-dialog ref="editWhereaboutsDialog" />
    -->
    <!-- 勤怠入力Dialog -->
    <telework-dialog ref="teleworkDialog" />
    <!-- 行先入力連動送信Dialog -->
    <telework-link-input-dialog ref="teleworkLinkInputDialog" @onUpdateWhereabouts="onUpdateWhereabouts"/>
    <!-- 休暇Dialog -->
    <holiday-dialog ref="holidayDialog" @onUpdateWhereabouts="onUpdateWhereabouts"/>
    <!-- データ送信失敗Alart -->
    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">{{ $t("errmsg.sendfailed") }}</div>
    </errorinfo-dialog>
    <error-confirm-dialog ref="errorConfirmDialog">
      <div slot="msg">{{mErrMsg}}</div>
    </error-confirm-dialog>
 </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { ROUTE_PATH } from '@/router/routes'
import { mapState } from 'vuex'
import {
  //TIME_DIFERENCE,
  isUndefined,
  isNullorUndefined,
  formatDateMoment,
  LinkedWhCategory,
  //calcHour
} from '@/common'
import { placeIdToStr } from '@/store'
import TeleworkDialog from '@/components/dialogs/TeleworkDialog'
import teleworkLinkInputDialog from '@/components/dialogs/TeleworkLinkInputDialog'
import HolidayInfoDialog from '@/components/dialogs/HolidayInfoDialog'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import ErrorConfirmDialog from '@/components/dialogs/ErrorConfirmDialog'
import UpdateFloatBtn from '@/components/parts/UpdateFloatBtn'
import Loading from '@/components/parts/Loading'

export default {
  name: 'SelectedWhereaboutsInfo',
  data: () => ({
    mPresenceDefault: {
      state_id: 0,
      st_name: '-',
      icon_name: 'error',
      icon_color: 'white',
    },
    mPresenceNoState: {
      state_id: 0,
      st_name: '-',
      icon_name: 'error',
      icon_color: 'grey lighten-3',
    },
    mPlaceList: [],
    mDpicker: false,
    mDpickerMon: false,
    mTpicker: false,
    mTpickerMon: false,
    mTmpRetTime: '',
    mSwiFormValid: true,
    mSwiCommentRules: {
      counter: v => ((v == null) || (v.length <= 150)) || 'メモ欄は150文字以内で入力してください',
    },
    mBeforeStateId: null,
    mLinkedWhCategory: LinkedWhCategory,
    mAvatarSizeMoobile: window.innerWidth * 0.15,
    mAvatarSizeMonitor: window.innerWidth * 0.05,
    mSelectedUserInfo: { user_id: '', section: '', group: '', class: '', avatar: '' },
    mIsMounted: false,
    mIsAutoLoading: false,    // 画面フォーカス契機で再取得を行ったデータの場合true
    mErrMsg: '',
  }),
  components: {
    'telework-dialog': TeleworkDialog,
    'telework-link-input-dialog': teleworkLinkInputDialog,
    'holiday-dialog': HolidayInfoDialog,
    'errorinfo-dialog': ErrorInfoDialog,
    'error-confirm-dialog': ErrorConfirmDialog,
    'update-btn': UpdateFloatBtn,
    'loading': Loading,
  },
  filters: {
    formatUpdateDate: function (time) {
      if (isNullorUndefined(time) || time === '') {
        return ''
      }
      //return formatDateMoment(calcHour(time, TIME_DIFERENCE), 'YYYY-MM-DD HH:mm')
      return ('最終更新  ' + formatDateMoment(time, 'YYYY-MM-DD HH:mm'))
    },
  },
  mounted: async function () {
    this.$log.debug('# SelectedWhereaboutsInfo ' + this.$route.params.id)
    // 表示ページをmemberに設定
    this.$store.dispatch('aChangeCurrentPage', 'member')

    if (!this.mIsMounted) {
      this.getWhereaboutsInfoByMember()
    }

    if (!isNullorUndefined(this.mWhereaboutsInfo.user_id)) {
      this.mSelectedUserInfo = this.getSelectedUserInfo()
    }
    this.mIsMounted = true

    // 行先一覧作成
    /*for (let key of Object.keys(this.mPlaceListStore)) {
      this.mPlaceList.push(this.mPlaceListStore[key].dist_name)
    }*/
  },
  destroyed: function () {
    this.$log.debug('# SelectedWhereaboutsInfo')
    this.$store.dispatch('aSelectUser', null)
    this.$store.commit('setUpbtnVisible', false)
  },
  watch: {
    mSelectedMemberId: function (current, previous) {
      if (!isNullorUndefined(this.mSelectedMemberId)) {
        if (!this.mSelectedUserInfo || (this.mSelectedUserInfo && (this.mSelectedUserInfo.user_id !== this.mSelectedMemberId))) {
          this.mSelectedUserInfo = this.getSelectedUserInfo()
        }
      }
    },
    // @Memo watchはオブジェクトの中身は検知できないので、個々のpropertyで検知する
    'mWhereaboutsInfo.state': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★状態(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        this.$store.commit('setUpbtnVisible', true)
      }
      else if (isUndefined(previous)) {
        this.mBeforeStateId = this.mWhereaboutsInfo.state
      }
    },
    'mWhereaboutsInfo.move_direct': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★直行直帰(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        this.$store.commit('setUpbtnVisible', true)
      }
    },
    'mWhereaboutsInfo.dist': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★行先(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        if (previous !== '') {  // IE11対応（ロジックでは、''になることはないが、IE11の場合''になる）
          this.mWhereaboutsInfo.dist_name = placeIdToStr(current, this.mPlaceListStore)
          this.$store.commit('setUpbtnVisible', true)
        }
      }
    },
    'mWhereaboutsInfo.ret_date': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★帰社日(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        this.$store.commit('setUpbtnVisible', true)
      }
    },
    'mWhereaboutsInfo.ret_time': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★帰社時間(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        this.$store.commit('setUpbtnVisible', true)
      }
    },
    'mWhereaboutsInfo.comment': function (current, previous) {
      // 初回表示時、終了時、自動更新の変化は無視する
      //this.$log.debug('★メモ(' + previous + ')→(' + current + ') user_id(' + this.mWhereaboutsInfo.user_id + ') valid(' + this.mSwiFormValid + ') autoLoading(' + this.mIsAutoLoading + ')')
      if (!isUndefined(previous) && !isUndefined(current) && this.mSwiFormValid && !this.mIsAutoLoading) {
        this.$store.commit('setUpbtnVisible', true)
      }
    },
    mSwiFormValid: function (current, previous) {
      if (current) {
        this.$store.commit('setUpbtnVisible', true)
      }
      else {
        this.$store.commit('setUpbtnVisible', false)
      }
    },
    /*'$window.isFocus': function (current, previous) {
      //if (current && !this.$store.getters.isMobile) {
      if (current) {
        // ブラウザ版の場合はFocus検知
        this.onSwiFocus()
      }
    },*/
    '$window.isResume': function (current, previous) {
      if (current && this.$store.getters.isMobile) {
        // ブラウザ版の場合はResume検知
        this.onSwiFocus()
      }
    },
  },
  computed: {
    ...mapState({
      mSelectedMemberId: state => state.sSelectedMemberId,
      mWhereaboutsInfo: state => state.sSelectedWhereaboutsInfo,
      mPlaceListStore: state => state.sPlaceList,
      mPresenceStatusList: state => state.sPresenceStatusList,
      //mTelework: state => state.loginUser.sUserBaseInfo.telework,
      mAttendance: state => state.loginUser.sUserBaseInfo.attendance_flg,
      mLinkedTw: state => state.loginUser.sUserBaseInfo.linked_wh_flg,
      //mTwUserList: state => state.sTeleworkingUserList,
      mLatestWhCategory: state => state.loginUser.sUserInfo.latest_wh_category,
      //calendarKey: state => state.sSelectedMemberCalendarKey,
      mCurrentPage: state => state.currentPage.sCurrentPage
    }),
    goDirect: function () {
      return (this.mWhereaboutsInfo.move_direct === 1) || (this.mWhereaboutsInfo.move_direct === 3)
    },
    comeDirect: function () {
      return (this.mWhereaboutsInfo.move_direct === 2) || (this.mWhereaboutsInfo.move_direct === 3)
    },
    currentPresence: function () {
      return this._findPresenceStatus(this.mWhereaboutsInfo.state)
    },
    attendanceAvailable: function () {
      return ((this.mWhereaboutsInfo.user_id === this.$store.getters.loginUserId) && (this.mAttendance === 1))
    },
    /* 20220524 y.jin start
      ※メール連携機能(電話連携と同時リリースするため、リリース保留)
    isLoginUser: function () {
      return (this.mWhereaboutsInfo.user_id === this.$store.getters.loginUserId)
    },
    */
    // Telework機能ボタン表示
    /*teleworkFunction: function () {
      return { 'hm-swi-telework-blind': !(this.telework && (this.mWhereaboutsInfo.user_id === this.$store.getters.loginUserId)) }
    },*/
    /*attendanceIconDisabled: function () {
      // 2.5
      if (this.mWhereaboutsInfo.user_id !== this.$store.getters.loginUserId) {
        return false
      }

      if (this.mAttendance !== 1) {
        // 勤怠管理フラグがONでは無い場合
        return false
      }
      // 最終勤務種別が勤務中状態かどうかチェック
      if ((this.mLatestWhCategory === 1) ||
          (this.mLatestWhCategory === 2) ||
          (this.mLatestWhCategory === 3)) {
        return true
      }
      else {
        return false
      }

      // ～2.4
      if (this.mWhereaboutsInfo.attendance_flg !== 1) {
        // 勤怠管理フラグがONでは無い場合
        return false
      }

      // 表示対象のstaff_idが、勤務中ユーザリストに存在するか検索
      let result = false
      const twUserist = this.$store.getters.teleworkingUserList
      if (isNullorUndefined(twUserist)) {
        return false
      }
      if (twUserist.indexOf(this.mWhereaboutsInfo.staff_id) >= 0) {
        result = true
      }
      this.$log.debug('★[attendanceIconDisabled] result(' + result + ')')
      return result
    },*/
    // Calendar表示
    /*
    calendarAvailableStyle: function () {
      return { 'hm-swi-calendar-blind': (this.calendarKey === null || this.calendarKey === '') }
    },
    */
    updateDateDisp: function () {
      return !(isNullorUndefined(this.mWhereaboutsInfo.update_date) || this.mWhereaboutsInfo.update_date === '')
    },
    isAvatarAvailable: function () {
      return !(isNullorUndefined(this.mSelectedUserInfo.avatar) || this.mSelectedUserInfo.avatar === '')
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    onSwiFocus: function () {
      if (this.mCurrentPage === 'member' && !this.$store.getters.isUpbtnVisible && this.mSwiFormValid) {
        // アプリ版行先詳細画面で、送信アイコンが表示されていない場合、再取得を行う
        // (何らかの情報を入力中、または入力エラーの場合は再取得しない)
        //this.$log.debug('onSwiFocus')
        this.mIsAutoLoading = true
        this.getWhereaboutsInfoByMember()
      }
    },
    // -------------------------------------------------------------------------
    onSwipe: function (direction) {
      switch (direction) {
        case 'left':
          this.onSwipeLeft()
          break
        case 'right':
          this.onSwipeRight()
          break
        default:
          break
      }
    },
    // -------------------------------------------------------------------------
    onSwipeLeft: function () {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_LIST)
    },
    // -------------------------------------------------------------------------
    onSwipeRight: function () {
      this.$router.push(ROUTE_PATH.ROUTE_MAP_LOCATION)
    },
    // -------------------------------------------------------------------------
    onClickPresenceIcon: function (statusId, LinkedTwCategory) {
      this.mIsAutoLoading = false
      this.mWhereaboutsInfo.state = statusId    // 更新情報に選択した状態IDを設定
      this._findPresenceStatus(statusId)

      if (this.$store.getters.loginUserId === this.$store.getters.selectedMemberId &&
          this.mWhereaboutsInfo.attendance_flg === 1 &&
          this.mLinkedTw === 1) {
        // ログインユーザであり、勤怠管理フラグがON かつ 行先入力連動設定がONの場合

        if (!this.mSwiFormValid) {
          // 行先情報入力エラー
          return
        }

        if (LinkedTwCategory === this.mLinkedWhCategory.START ||
            LinkedTwCategory === this.mLinkedWhCategory.LEAVE ||
            LinkedTwCategory === this.mLinkedWhCategory.END) {
          // 連動する勤務種別が勤怠関連の場合、行先入力連動ダイアログを開く
          this.$refs.teleworkLinkInputDialog.$emit(
            'onClickTelework',
            LinkedTwCategory
          )
        }
        else if (LinkedTwCategory === this.mLinkedWhCategory.HOLIDAY) {
          // 連動する勤務種別が休暇の場合、休暇情報ダイアログを開く
          const sendData = {
            list_row: -1,
            workinghour_id: null,
            category: null,
            date: null,
            comment: null,
            update_date: null
          }
          this.$refs.holidayDialog.$emit(
            'onClickHolidayInfo',
            sendData
          )
        }
      }
    },
    // -------------------------------------------------------------------------
    onClickCurrentPresence: function () {
      this.mIsAutoLoading = false
      this.mWhereaboutsInfo.move_direct = (this.mWhereaboutsInfo.move_direct + 1) % 4
    },
    /*
    // -------------------------------------------------------------------------
    // on Click Edit Whereabouts
    onClickEditWhereabouts: function () {
      this.$refs.editWhereaboutsDialog.$emit('onClickEditWhereabouts')
    },
    */
    // -------------------------------------------------------------------------
    // on Click Telework from child
    /*teleworkClicked: function () {
      this.$refs.teleworkDialog.$emit('onClickTelework')
    },*/
    // -------------------------------------------------------------------------
    // on Click Attendance Send Icon
    onClickAttendanceSend: function () {
      this.mIsAutoLoading = false
      this.$refs.teleworkDialog.$emit(
        'onClickTelework',
        this.$store.getters.loginUserCompanyId,
        this.$store.getters.loginUserId,
        this.$store.getters.loginUserBaseInfo.staff_id
      )
    },
    // -------------------------------------------------------------------------
    // on Click Update
    onClickUpdate: function () {
      this.$refs.updateBtn.$emit('onClickUpdate', this.mWhereaboutsInfo)
    },
    // -------------------------------------------------------------------------
    // on Click Mail Icon (for mobile)
    /* 20220524 y.jin start
      ※メール連携機能(電話連携と同時リリースするため、リリース保留)
    onClickMail: async function () {
      let mailtoStr = 'mailto:' + this.mSelectedUserInfo.mail
      let userAgent = checkUserAgentForApp()
      if (userAgent.match(/Android/) !== null) {
        window.plugins.webintent.startActivity(
          {
            action: window.plugins.webintent.ACTION_VIEW,
            url: mailtoStr
          },
          function () {},   // 正常時処理
          function () {},   // 異常時処理
        )
      }
      else {
        cordova.InAppBrowser.open(mailtoStr, '_system', 'location=yes')
      }
    },
    */
    // -------------------------------------------------------------------------
    // サーバ送信ボタン押下時の処理
    onUpdateWhereabouts: async function (status) {
      if (!this.mSwiFormValid) {
        return
      }
      this.mIsAutoLoading = false
      //this.$refs.infoSnackbar.$emit('show')
      this.$refs.loading.$emit('show')

      const result = await this.$store.dispatch(
        'aUpdateWhereaboutsInfo',
        {
          companyId: this.$store.getters.loginUserCompanyId,
          loginUserId: this.$store.getters.loginUserId
        })
      if ((!result.error) && (!result.body.error)) {
        this.$emit('updateWhereaboutsInfo')  // WhereaboutsListに対するイベント(Mobileでは無視される)

        // 選択されているユーザがログインユーザの場合
        if (this.$store.getters.loginUserId === this.$store.getters.selectedMemberId) {
          // ログイン情報を更新
          this.mWhereaboutsInfo.latest_wh_category = this.mLatestWhCategory   // 行先一覧情報にlatest_wh_categoryがないため追加
          //this.$log.debug('★ログインユーザの行先情報更新：' + JSON.stringify(this.mWhereaboutsInfo))
          this.$store.dispatch('aSetLoginUserInfo', this.mWhereaboutsInfo)

          // 現在の状態IDを、変更前情報として保持
          this.mBeforeStateId = this.mWhereaboutsInfo.state
        }

        // updateに成功したらOrgWhereaboutsを書き換える
        //this.mOrgWhereaboutsInfo = Object.assign({}, this.$store.getters.selectedWhereaboutsInfo)
        // @Todo 場当たり的な実装になるのでここでは変更したくない
        //this.mOrgWhereaboutsInfo.comment = this.mOrgWhereaboutsInfo.comment || '-'
        this.mOrgWhereaboutsInfo = null

        this.$store.commit('setUpbtnVisible', false)    // 送信ボタン非表示
      }
      else {
        if (result.status === 'IpError') {
          this.mErrMsg = 'このIPアドレスからのアクセスは許可されていません'
          this.$refs.errorConfirmDialog.$emit('show', this.dispLoginPage)
        }
        else {
          this.$refs.errorInfoDialog.$emit('show')
        }
      }

      //this.$refs.infoSnackbar.$emit('hide')
      this.$refs.loading.$emit('hide')
    },
    // -------------------------------------------------------------------------
    _findPresenceStatus: function (statusId) {
      // 本Componentが読み込まれるタイミングによってはnullの場合がある
      // その場合はdefault値を返す
      if (isNullorUndefined(statusId)) {
        // 表示するユーザの情報がまだ無い時
        return this.mPresenceDefault
      }
      let presenceStatus = this.mPresenceStatusList.find((elm) => {
        return (elm.state_id.toString() === statusId.toString())
      })

      if (isNullorUndefined(presenceStatus)) {
        this.$log.error('current presence status is null.')
        // 見つからない場合はdefault値を返す
        return this.mPresenceNoState
      }
      return presenceStatus
    },
    // -------------------------------------------------------------------------
    _copyWhereaboutsInfo: function () {
      this.mOrgWhereaboutsInfo = Object.assign({}, this.mWhereaboutsInfo)
      /*
      if (this.mOrgWhereaboutsInfo.comment === '') {
        this.mOrgWhereaboutsInfo.comment = '-'
      }
      */
    },
    // -------------------------------------------------------------------------
    onClickMemoClear: function () {
      this.mIsAutoLoading = false
      this.mWhereaboutsInfo.comment = ''
    },
    // -------------------------------------------------------------------------
    onMemoFocus: function () {
      this.mIsAutoLoading = false
      this.$store.commit('setIsEdit', true)
    },
    // -------------------------------------------------------------------------
    onMemoBlur: function () {
      this.mIsAutoLoading = false
      this.$store.commit('setIsEdit', false)
    },
    onClickDist: function () {
      this.mIsAutoLoading = false
    },
    // -------------------------------------------------------------------------
    onClickDatetimeClear: function () {
      this.mIsAutoLoading = false
      this.mWhereaboutsInfo.ret_date = null
      this.mWhereaboutsInfo.ret_time = null
    },
    // -------------------------------------------------------------------------
    onClickRetTime: function () {
      this.mIsAutoLoading = false
      if (this.mWhereaboutsInfo.ret_time === null) {
        this.mTmpRetTime = '00:00'
      }
      else {
        this.mTmpRetTime = this.mWhereaboutsInfo.ret_time
      }
    },
    onRetDateFocus: function () {
      this.mIsAutoLoading = false
    },
    // -------------------------------------------------------------------------
    onClickRetTimeOk: function () {
      if (this.$store.getters.isMobile) {
        this.$refs.timemenu.save(this.mTmpRetTime)
      }
      else {
        this.$refs.timemenuMon.save(this.mTmpRetTime)
      }
    },
    // -------------------------------------------------------------------------
    onClickRetTimeCancel: function () {
      if (this.$store.getters.isMobile) {
        this.mTpicker = false
      }
      else {
        this.mTpickerMon = false
      }
      if (this.mWhereaboutsInfo.ret_time === '00:00') {
        this.mWhereaboutsInfo.ret_time = null
      }
    },
    // -------------------------------------------------------------------------
    allowedMinutes: function (v) {
      return ((v % 5) === 0)
    },
    // -------------------------------------------------------------------------
    getWhereaboutsInfoByMember: async function () {
      // routeにidがセットされている場合は、選択ユーザとして情報を取得する
      if (!isNullorUndefined(this.$route.params.id)) {
        this.mSwiFormValid = true

        await this.$store.dispatch(
          'aGetSelectUser',
          {
            companyId: this.$store.getters.loginUserCompanyId,
            memberId: this.$route.params.id,
          })
        //this.$log.debug('selected whereabouts info' + JSON.stringify(this.mWhereaboutsInfo))
        this.mIsMounted = true
      }
    },
    getSelectedUserInfo: function () {
      //this.$log.debug('★[getSelectedUserInfo]')
      const userlist = this.$store.getters.userList
      const data = userlist.find((data) => {
        return (data.user_id.toString() === this.mSelectedMemberId.toString())
      })
      //this.$log.debug('★選択ユーザ：' + JSON.stringify(data))
      if (isNullorUndefined(data)) {
        this.$log.error('userinfo is null or undefined.')
        return {
          user_id: this.mSelectedMemberId,
          section: '',
          group: '',
          class: '',
          avatar: '',
          mail: ''
        }
      }

      let sectionData = this.$store.getters.fSection(data.section)
      let groupData = this.$store.getters.fGroup(data.group_id)
      let classData = this.$store.getters.fClass(Number(data.class))
      let avatar = (isNullorUndefined(data.avatar) || data.avatar === '') ? '' : (data.avatar + '?' + Date.now())

      return {
        user_id: this.mSelectedMemberId,
        section: (sectionData.length !== 0) ? sectionData[0].s_name : '',
        group: (groupData.length !== 0) ? groupData[0].g_name : '',
        class: (classData).length !== 0 ? classData[0].c_name : '',
        avatar: avatar,
        mail: data.mail
      }
    },
    // -------------------------------------------------------------------------
    // IPエラーダイアログのコールバック関数
    dispLoginPage: function () {
      this.$router.push(ROUTE_PATH.ROUTE_LOGIN)
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-display-none {
  display: none;
}
.hm-swi {
  margin-top: 1vh;
  /*height: 100vh;*/
}
.hm-swi-profile {
  padding: 5px 0px;
}
.hm-swi-avatar {
  margin-top: 3px;
  margin-bottom: 3px;
}
.hm-swi-name {
  /*margin-bottom: 2vh;*/
  /*line-height: 52px;*/
  /*padding: 10px;*/
  font-size: 1em;
  text-align: left;
  padding-left: 10px;
}
.hm-swi-usersection,
.hm-swi-userclass {
  font-size: 0.75em;
}
.hm-swi-username {
  font-size: 1.2em;
  font-weight: bold;
}
@media screen and (min-width: 601px) {
.hm-swi-usersection,
.hm-swi-userclass {
  font-size: 0.9em;
}
.hm-swi-username {
  font-size: 1.5em;
}
}
.hm-swi-updatedate {
  height: 15px;
  line-height: 15px;
  margin: 0 auto;
  font-weight: normal;
  font-size: 0.9em;
}
.hm-swi-icon-back {
  margin: 0px 5px;
  height: 12vh;
  width: 50vw;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
}
@media screen and (min-width: 601px) {
.hm-swi-icon-back {
  height: 100px;
  width: 15vw;
}
}
.hm-swi-icon-text {
  font-weight: bold;
}
.hm-swi-icon-blind {
  display: none;
}
.hm-swi-icon-list-back {
  height: 12vw;
  width: 12vw;
  padding: 5vw;
  border-radius: 5px;          /* css3 draft */
  -webkit-border-radius: 5px;  /* Safari, Chrome */
  -moz-border-radius: 5px;     /* Firefox */
}
@media screen and (min-width: 601px) {
.hm-swi-icon-list-back {
  height: 24px;
  width: 24px;
  padding: 24px;
}
}
.hm-swi-icon-list {
  margin: 1.5vh auto;
}
.hm-swi-divider {
  margin: 1vh auto;
}
@media screen and (min-width: 601px) {
.hm-swi-divider {
  margin-bottom: 0.25vh auto;
}
}

.hm-swi-place-detail {
  margin-top: 1vh;
  text-align: left;
  /*border-bottom: solid 10px #8b0000;*/
}
.hm-swi-whereabouts-title {
  text-align: center;
}
.hm-swi-whereabouts-list-title {
  text-align: left;
  font-size: 0.9em;
  font-weight: bold;
  color: #8b0000;
}
.hm-swi-whereabouts-list-body {
  margin: auto 10px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555555;
}
.hm-swi-telework-blind {
  display: none;
}
.hm-swi-calendar-blind {
  display: none;
}
.hm-swi-presence-card {
  padding: 8px;
  margin-top: 1vh;
  margin-bottom: 10px;
}
.hm-swi-presence-text {
  color: white;
  font-weight: bold;
}
.hm-swi-scroll-wrapper {
  padding: 5px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.hm-swi-iconlist {
  display: inline-block;
}
.hm-swi-direct-go {
  margin: 2vh 30px 5px 30px;
  padding: 2px;
  text-align: center;
  color: #8b0000;
  background-color: white;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
}
.hm-swi-direct-bk {
  margin: 0 30px 5px 30px;
  padding: 2px;
  text-align: center;
  color: white;
  background-color: #8b0000;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
}
@media screen and (min-width: 601px) {
.hm-swi-direct-go {
  margin: 2vh 70px 5px 70px;
}
.hm-swi-direct-bk {
  margin: 0 70px 5px 70px;
}
}
.hm-swi-box {
  margin-top: 5px;
  padding-top: 5px;
  border-top: solid 5px #8b0000;
}
@media screen and (min-width: 601px) {
.hm-swi-box {
  border-top: solid 5px #8b0000;
}
}
.hm-swi-twfont {
  font-size: 0.2em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectedWhereaboutsInfo.vue